import { render, staticRenderFns } from "./BannerManageItem.vue?vue&type=template&id=1dd44143"
import script from "./BannerManageItem.vue?vue&type=script&lang=js"
export * from "./BannerManageItem.vue?vue&type=script&lang=js"
import style0 from "./BannerManageItem.vue?vue&type=style&index=0&id=1dd44143&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports